export const COOKIE_EMBED_NAME = 'APP_EMBEDDED';

export const ALLOWED_LINEUP_EMBED_ORIGINS = [
  'http://localhost:3000',
  'http://localhost:3001',
  'https://dev.mdlbeast.com',
  'https://mdlbeast.com',
] as const;
